export const root = 'pn-ProductNav'
export const container = 'pn-ProductNavContents'
export const slidesContainer = 'pn-ProductContainer'
export const item = 'pn-ProductNavLinkWrapper'
export const next = 'pnAdvancerRight'
export const prev = 'pnAdvancerLeft'
export const pnIndicator = 'pn-ProductNavIndicator'
export const link_plp_category_padding_x = 10
export const TRANSITION_FAST = 300

export const colours = {
    0: '#000000',
    1: '#000000',
    2: '#99813D',
    3: '#40FEFF',
    4: '#14CC99',
    5: '#00BAFF',
    6: '#0082B2',
    7: '#B25D7A',
    8: '#00FF17',
    9: '#006B49',
    10: '#00B27A',
    11: '#996B3D',
    12: '#CC7014',
    13: '#40FF8C',
    14: '#FF3400',
    15: '#ECBB5E',
    16: '#ECBB0C',
    17: '#B9D912',
    18: '#253A93',
    19: '#125FB9'
}
